'use strict';

var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var Radio = require('backbone.radio');
var moment = require('moment-timezone');
var Marionette = require('backbone.marionette');
var polyglot = require('../../utilities/polyglot').default;

var LoadingView = require('../loading').default;
var StaffView = require('../staff/select').default;
var WaitListView = require('../requests/form').default;
var Tracker = require('../../../analytics/events').default;
var DatePickerView = require('../date-picker/picker').default;
var TimesCollection = require('../../collections/times').default;
var CalendarCollectionView = require('./calendar-collection').default;
var AdvancedWaitListView = require('../requests/advanced-form').default;
var TimezonePickerModal = require('../timezone-picker/timezone-modal').default;
var TimezoneNotificationView = require('../timezone-picker/notification').default;
var TimeSelectionEvents = require('../../../analytics/time-selection-events').default;
var TimezonePickerContainerView = require('../timezone-picker/timezone-container').default;

export default Marionette.View.extend({

  className: 'calendar',
  childViewContainer: '.calendar-days',
  template: require('./templates/calendar.hbs'),
  backButton: '.calendar-back',
  nextButton: '.calendar-next',

  isDesktop: false,
  shouldShowTimezonePopup: true,

  regions: {
    calendar: {
      el: '.calendar-days',
      replaceElement: true,
    },
  },

  ui: {
    month_view_calendar: '.month-view-calendar',
    header: '.calendar-header',
    footer: '.calendar-footer',
    next: '.calendar-next',
    back: '.calendar-back',
    waitlist: '.calendar-wait-list-link',
    waitlist_message: '.calendar-wait-list-message',
    timezone: '.timezone',
    timezone_picker: '.timezone-picker-container',
    calendar_picker: '.calendar-picker-icon',
    date_range: '.date-range',
    staff_select: '.adjust-select-width',
  },

  events: {
    'click @ui.timezone': 'onClickTimezone',
    'click @ui.calendar_picker': 'toggleMonthView',
    'click @ui.waitlist': 'onClickWaitList',
    'click @ui.next': 'onClickNext',
    'click @ui.back': 'onClickBack',
  },

  childViewEvents: {
    updateBackAndNextButtons: 'updateBackAndNextButtonState',
    navigateNext: 'onClickNext',
    navigateBack: 'onClickBack',
    showTimezonePopup: 'showTimezonePopup',
    childClickTime: 'onChildViewClickTime',
    loading: 'showLoadingView',
    loadingDone: 'hideLoadingView',
    setStaff: 'setStaff',
    setEnd: 'setEnd',
  },

  initialize: function (options) {
    this.appointment = options.appointment;
    this.locations = options.locations;
    this.staff = options.staff;
    this.services = options.services;
    this.collection = new TimesCollection();
    this.requests = [];
    this.start = moment().startOf('day');
    this.end = this.initializeEnd(this.start);
    this.daysShown = 0;
    this.timezoneNotificiationView = new TimezoneNotificationView({
      appointment: this.appointment,
    });
    this.maxInitialSearchDays = 252; // 9 months
    this.displayStaffPicker = window.SETTINGS.show_staff_picker;

    this.calendarCollectionView = new CalendarCollectionView({
      appointment: this.appointment,
      collection: this.collection,
      staff: this.staff,
      start: this.start,
      end: this.end,
      fetchTimes: _.bind(this.fetchTimes, this),
      hasActiveRequests: _.bind(this.hasActiveRequests, this),
    });

    this.loadingView = new LoadingView();

    this.datePickerView = new DatePickerView({
      appointment: this.appointment,
      current: this.calendarCollectionView.getCurrentDay(),
      length: this.calendarCollectionView.getPageSize(),
      max: window.SETTINGS.time_in_advance ? moment().add(window.SETTINGS.time_in_advance, 'minutes') : null,
      collection: this.collection,
      collectionEnd: this.end,
      fetchTimes: _.bind(this.fetchTimes, this),
      hasActiveRequests: _.bind(this.hasActiveRequests, this),
    });
    this.datePickerView.on('setEnd', _.bind(this.setEnd, this));

    this.staffView = new StaffView({
      collection: window.SETTINGS.show_staff_picker ? this.staff : new Backbone.Collection(),
      selectedStaff: this.appointment.staff,
      childViewOptions: {
        collection: this.staff,
        selectedStaff: this.appointment.staff,
      },
    });

    // the index of matching query is equal the number of days shown - 1
    this.mediaQueriesDaysShown = [
      window.matchMedia('(max-width: 768px)'),
      window.matchMedia('(min-width: 768px) and (max-width: 850px)'),
      window.matchMedia('(min-width: 850px) and (max-width: 1000px)'),
      window.matchMedia('(min-width: 1000px) and (max-width: 1150px)'),
      window.matchMedia('(min-width: 1150px)'),
    ];

    Radio.channel('timezone').off('change');
    Radio.channel('timezone').on('change', _.bind(this.onChangeTimezone, this));
    this.listenTo(Radio.channel('calendar'), 'navigate', this.navigateCalendar);
    this.listenTo(Radio.channel('calendar'), 'setFirstDateShown', this.setFirstDateShown);
    this.listenTo(this.datePickerView, 'change:date', this.onDatePickerChangeDate);
    if (this.displayStaffPicker) {
      this.listenTo(this.staffView, 'change:staff', this.onClickEmployee);
    }
  },

  initializeEnd: function (start) {
    if (window.SETTINGS.time_in_advance) {
      return start.clone().add(window.SETTINGS.time_in_advance, 'minutes');
    }

    return start.clone().add(2, 'month').startOf('month');
  },

  onRender: function () {
    var onReschedule = Backbone.history.getFragment() === polyglot.t('pages.reschedule.slug');

    this.$el.prepend(this.loadingView.render().el);
    this.loadingView.$el.addClass('time-step');
    if (onReschedule || !window.SETTINGS.wait_list) {
      this.$el.addClass('no-wait-list');
    }

    this.showDatePickerView();

    $('.l-time-step').append(this.timezoneNotificiationView.render().el);
    if (this.appointment.get('timezone_proper')) {
      this.timezoneNotificiationView.hide();
    }

    if (!onReschedule && window.SETTINGS.wait_list && this.$el.hasClass('no-wait-list')) {
      this.$el.removeClass('no-wait-list');
    }

    this.showChildView('calendar', this.calendarCollectionView);
    // this is needed on initial render of the calendarCollectionView
    this.calendarCollectionView.setCalendarMonth();
    if (this.appointment.isPrivate()) {
      this.ui.header.hide();
    }

    this.boundAdjustDateRangeMessageForQuery = _.bind(this.adjustDateRangeMessageForQuery, this);
    this.mediaQueriesDaysShown.forEach((query) => {
      query.addListener(this.boundAdjustDateRangeMessageForQuery);
    });
    this.adjustDateRangeMessage();

    if (this.displayStaffPicker) {
      this.ui.staff_select.append(this.staffView.el);
      this.staffView.render();
    }
  },

  onBeforeDetach: function() {
    this.mediaQueriesDaysShown.forEach((query) => {
      query.removeListener(this.boundAdjustDateRangeMessageForQuery);
    });
  },

  showDatePickerView: function() {
    this.ui.month_view_calendar.html(this.datePickerView.render().el);
    this.datePickerView.focusFirst();
    this.closeTimezonePicker();
  },

  navigateCalendar: function (keyCode) {
    this.calendarCollectionView.navigateCalendar(keyCode);
  },

  showLoadingView: function () {
    this.loadingView.show();
  },

  hideLoadingView: function () {
    this.loadingView.hide();
  },

  onClickWaitList: function (evt) {
    evt.preventDefault();
    Tracker.trackView('waitlist-create-modal');

    if (window.SETTINGS.advanced_wait_list) {
      Radio.channel('modal').trigger('show', new AdvancedWaitListView({
        model: this.appointment.createRequest(),
        staff: this.staff,
      }));
    } else {
      Radio.channel('modal').trigger('show', new WaitListView({
        model: this.appointment.createRequest(),
        smsEnabled: this.appointment.isSmsEnabled(),
        locations: this.locations,
        services: this.services,
      }));
    }
  },

  onClickTimezone: function (evt) {
    evt.preventDefault();
    TimeSelectionEvents.trackClick('Timezone picker');
    this.timezoneNotificiationView.close();

    if (this.ui.timezone_picker.is(':visible')) {
      this.closeTimezonePicker();
    } else {
      this.closeMonthView();

      var mobileBreakpoint = window.matchMedia('(max-width: 700px)');
      if (mobileBreakpoint.matches) {
        Radio.channel('modal').trigger('show', new TimezonePickerModal());
      } else {
        var view = new TimezonePickerContainerView();
        this.listenTo(view, 'change', _.bind(this.closeTimezonePicker, this));
        this.listenTo(view, 'closeTimezonePicker', _.bind(this.closeTimezonePicker, this));
        this.ui.timezone_picker.html(view.render().el);
        this.ui.timezone_picker.show();
        this.ui.timezone.attr('aria-expanded', 'true');
        view.focusFirst();
      }
    }
  },

  onClickEmployee: function (model) {
    this.triggerMethod('change:staff', model);
  },

  closeMonthView: function () {
    this.ui.month_view_calendar.addClass('hidden');
  },

  toggleMonthView: function () {
    if (this.ui.month_view_calendar.hasClass('hidden')) {
      this.closeTimezonePicker();
      this.ui.month_view_calendar.removeClass('hidden');
    } else {
      this.ui.month_view_calendar.addClass('hidden');
    }
  },

  onChildViewClickTime: function (timeModel, timeString) {
    this.trigger('change:time', timeModel, timeString);
  },

  closeTimezonePicker: function () {
    this.ui.timezone.focus();
    this.ui.timezone.attr('aria-expanded', 'false');
    this.ui.timezone_picker.empty();
    this.ui.timezone_picker.hide();
  },

  onDatePickerChangeDate: function (date) {
    this.calendarCollectionView.setCurrentIndex(date);
    this.calendarCollectionView.scrollToCurrentPage();
    if (!this.calendarCollectionView.needToLoadPages()) {
      this.calendarCollectionView.setCalendarMonth();
      this.updateBackAndNextButtonState();
    }
    this.toggleMonthView();
  },

  onScreenResize: function () {
    this.calendarCollectionView.scrollToCurrentPage();
    this.updateBackAndNextButtonState();
    this.datePickerView.updateCurrentAndLength(this.firstDateShown, this.daysShown);
  },

  onChangeTimezone: function () {
    this.collection = new TimesCollection(
      this.collection.adjustWithTimezone(this.appointment),
    );
    this.datePickerView.setCollection(this.collection);
    this.calendarCollectionView.setCollection(this.collection);
    this.datePickerView.render();
    this.calendarCollectionView.render();
  },

  serializeData: function () {
    return {
      showStaffPicker: this.displayStaffPicker,
    };
  },

  showTimezonePopup: function (timezone, abbreviation) {
    if (this.shouldShowTimezonePopup) {
      Radio.channel('toast').trigger('show', {
        message: polyglot.t('pages.times.timezone', {
          timezone: timezone,
          abbreviation: abbreviation,
        }),
        modalSize: 'small',
        icon: 'info-circle',
        buttonMessage: polyglot.t('messages.confirm'),
        skippable: false,
      });

      this.shouldShowTimezonePopup = false;
    }
  },

  setStaff: function (staff_id) {
    this.appointment.setStaff(this.staff.get(staff_id));
  },

  getFetchParameters: function () {
    var onReschedule = Backbone.history.getFragment() === polyglot.t('pages.reschedule.slug');
    var shortcuts = [
      ...(window.LOCATION ? [window.CONSTANTS.LOCATION] : []),
      ...(window.SERVICE ? [window.CONSTANTS.SERVICE] : []),
      ...(window.STAFF ? [window.CONSTANTS.STAFF] : []),
    ];

    var parameters = {
      is_rescheduling: onReschedule,
      location_id: this.appointment.get('location_id'),
      service_id: this.appointment.get('service_id'),
      preferred: false,
      start: this.start.format('YYYY-MM-DD'),
      end: this.end.format('YYYY-MM-DD'),
      ...(shortcuts.length ? { shortcuts } : {}),
    };

    if (this.appointment.has('staff_id')) {
      parameters.staff_id = this.appointment.get('staff_id');
      parameters.preferred = true;
    }

    return parameters;
  },

  setEnd: function (end) {
    this.end = end;
    this.calendarCollectionView.updateEnd(end);
    this.datePickerView.updateCollectionEnd(end);
  },

  fetchTimes: async function (fromDaysView = true) {
    var self = this;
    var requestNumber = self.requests.length;

    this.requests[requestNumber] = true;
    this.calendarCollectionView.showLoadingView();
    this.collection.fetch({
      data: self.getFetchParameters(),
      reset: true,
      success: function () {
        self.requests[requestNumber] = false;
        window.localStorage.removeItem('previous_timezone');
        self.collection = new TimesCollection(self.collection.adjustWithTimezone(self.appointment));
        self.calendarCollectionView.setCollection(self.collection);
        self.datePickerView.setCollection(self.collection);

        self.calendarCollectionView.render();

        if (fromDaysView) {
          self.calendarCollectionView.setCalendarMonth();
          // this will re-render the date picker view
          self.datePickerView.updateCurrentAndLength(self.firstDateShown, self.daysShown);
        } else {
          self.datePickerView.render();
        }

        self.calendarCollectionView.hideLoadingView();

        if (self.shouldFetchAgain()) {
          self.incrementEnd();
          self.fetchTimes();
        }
      },
      error: function () {
        self.requests[requestNumber] = false;
        self.calendarCollectionView.hideLoadingView();
      },
    });
  },

  incrementEnd: function () {
    this.end = this.end.clone().add(1, 'month').startOf('month');
    this.calendarCollectionView.updateEnd(this.end);
    this.datePickerView.updateCollectionEnd(this.end);
  },

  shouldFetchAgain: function () {
    var availableTimesCount = this.collection.getAvailableTimeCount();
    var notAtLimit = this.end.diff(this.start, 'days') <= this.maxInitialSearchDays;

    return !window.SETTINGS.time_in_advance && availableTimesCount === 0 && notAtLimit;
  },

  hasActiveRequests: function () {
    return _.some(this.requests);
  },

  // THE PAGED COLLECTION FUNCTIONALITY

  isBackEnabled: function () {
    return (this.calendarCollectionView.getCurrentPage() > 1);
  },

  isNextEnabled: function () {
    return (!window.SETTINGS.time_in_advance || this.calendarCollectionView.getCurrentPage() < this.calendarCollectionView.getNumberOfPages());
  },

  updateBackAndNextButtonState: function () {
    var $back = this.getBackButton();
    var $next = this.getNextButton();

    if ($back) {
      if (!this.isBackEnabled()) {
        $back.addClass('disabled');
      } else {
        $back.removeClass('disabled');
      }
    }

    if ($next) {
      if (!this.isNextEnabled()) {
        $next.addClass('disabled');
      } else {
        $next.removeClass('disabled');
      }
    }
  },

  getBackButton: function () {
    if (!this.backButton) {
      return null;
    }

    if (!this.$backButtonEl) {
      this.$backButtonEl = this.$(this.backButton);
    }

    return this.$backButtonEl;
  },

  getNextButton: function () {
    if (!this.nextButton) {
      return null;
    }

    if (!this.$nextButtonEl) {
      this.$nextButtonEl = this.$(this.nextButton);
    }

    return this.$nextButtonEl;
  },

  onClickBack: function (evt) {
    if (evt) {
      evt.preventDefault();
    }
    this.back();
  },

  back: function () {
    if (!this.isBackEnabled()) return;

    this.calendarCollectionView.moveToPrevPage();
    this.updateBackAndNextButtonState();
  },

  onClickNext: function (evt) {
    if (evt) {
      evt.preventDefault();
    }
    this.next();
  },

  next: function () {
    if (!this.isNextEnabled()) return;

    this.calendarCollectionView.moveToNextPage();
    this.updateBackAndNextButtonState();
  },

  setFirstDateShown: function (date) {
    this.firstDateShown = date.clone();
    this.adjustDateRangeMessage();
  },

  adjustDateRangeMessage: function () {
    var adjustDateRangeMessageForQuery = _.bind(this.adjustDateRangeMessageForQuery, this);
    this.mediaQueriesDaysShown.forEach((query, index) => {
      adjustDateRangeMessageForQuery(query, index);
    });
  },

  adjustDateRangeMessageForQuery: function (query, index = null) {
    if (query.matches) {
      var addDays = index === null
        ? this.mediaQueriesDaysShown.indexOf(query.currentTarget)
        : index;
      var lastDateShown = this.firstDateShown.clone().add(addDays, 'days');

      if (this.ui.date_range) {
        this.ui.date_range.html(this.formatDateRange(this.firstDateShown, lastDateShown));
      }

      this.daysShown = addDays + 1;
      this.onScreenResize();
    }
  },

  formatDateRange: function (start, end) {
    if (start.isSame(end)) {
      return `${start.format('L')}`;
    }

    return `${start.format('L')} - ${end.format('L')}`;
  },

});
